export const accentOptions = [
  { id: 'yomiri', name: 'Nyomiri', color: '#ff2e63', container: '#3d0d1b' },
  { id: 'cherry', name: 'Cereza', color: '#ff617e', container: '#41202b' },
  { id: 'violet', name: 'Violeta', color: '#b39aff', container: '#302343' },
  { id: 'mint', name: 'Menta', color: '#65dbc0', container: '#153c34' },
  { id: 'amber', name: 'Ámbar', color: '#f6bd68', container: '#40301d' },
  { id: 'sky', name: 'Cielo', color: '#78bfff', container: '#19334b' },
] as const;
export interface AppearancePreferences { accent: string; black: boolean; motion: boolean }
export function readAppearance(): AppearancePreferences {
  try { const saved = JSON.parse(localStorage.getItem('yomiri-appearance') || '{}'); return {
    accent: accentOptions.some(option => option.id === saved.accent) ? saved.accent : 'yomiri',
    black: saved.black === true, motion: saved.motion !== false,
  }; } catch { return { accent: 'yomiri', black: false, motion: true }; }
}
export function saveAppearance(value: AppearancePreferences) {
  localStorage.setItem('yomiri-appearance', JSON.stringify({...value,designVersion:'yomiri-1'}));
  window.dispatchEvent(new Event('yomiri-appearance-changed'));
}

export function subscribeAppearance(callback: (value: AppearancePreferences) => void) {
  const handler = () => callback(readAppearance());
  window.addEventListener('yomiri-appearance-changed', handler);
  return () => window.removeEventListener('yomiri-appearance-changed', handler);
}
